import i18n from '@/lib/i18n/i18n';

import type { RiskObjectGroups, ROFamilyMinimal } from '../types';

const GROUPS: RiskObjectGroups<ROFamilyMinimal> = [
  {
    title: 'RO_SECTION_OVERVIEW',
    properties: [
      {
        label: 'RO_FAMILY_NAME',
        getValue: (family) => family.name,
      },
      {
        label: 'RO_FAMILY_STATUS',
        getValue: (family) => i18n.t(`FAMILY_STATUS_${family.status}`),
      },
      // {
      //   label: 'RO_FAMILY_ADULTS',
      //   getValue: (family) => family.number_of_adults,
      // },
      // {
      //   label: 'RO_FAMILY_CHILDREN',
      //   getValue: (family) => family.number_of_children,
      // },
      // {
      //   label: 'RO_FAMILY_HAS_UNDERAGE',
      //   getValue: (family) => family.has_underage_children,
      // },
    ],
  },
];

export default GROUPS;
